import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconBathroom: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9 5a2 2 0 11-4 0 2 2 0 014 0zm-5 5c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H8v3c0 .6-.4 1-1 1s-1-.4-1-1v-3H5c-.6 0-1-.4-1-1v-6zm2 1v4h2v-4H6zm10-4a2 2 0 100-4 2 2 0 000 4zm.9 2.6l3 6c.1.3.2.6 0 .9-.2.3-.6.5-.9.5h-2v3c0 .6-.4 1-1 1s-1-.4-1-1v-3h-2c-.3 0-.8-.1-.9-.4-.1-.3-.2-.7 0-1l3-6c.3-.7 1.5-.7 1.8 0zm-.9 2.6L14.6 15h2.8L16 12.2z',
    })
  )
}
